export const SuperAdmin = "SuperAdmin";
export const CallCenterAgent = "CallAgent";
export const DoctorAssitant = "DoctorAssitant";